import * as React from 'react'

import { Box, HeaderText, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  children: React.ReactElement
}

const FormLayout = ({ children }: Props) => {
  return (
    <Box>
      <Box gap="s8" paddingBottom="s24">
        <HeaderText text={i18n.t('documents.modal.title')} />
        <Text size="300" color="grey800">
          {i18n.t('documents.modal.description')}
        </Text>
      </Box>
      <Box>{children}</Box>
    </Box>
  )
}

export default FormLayout
